// extracted by mini-css-extract-plugin
export var container = "_ds-0";
export var icon = "_ds-1";
export var text = "_ds-2";